'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.joinTeam = exports.createTeam = exports.fetchTeam = exports.fetchTeams = exports.deserializeTeam = undefined;

var _client = require('../../utils/client');

var _justgiving = require('./justgiving');

var _everydayhero = require('./everydayhero');

var deserializeTeam = exports.deserializeTeam = function deserializeTeam(team) {
  return (0, _client.isJustGiving)() ? (0, _justgiving.deserializeTeam)(team) : (0, _everydayhero.deserializeTeam)(team);
};

var fetchTeams = exports.fetchTeams = function fetchTeams(params) {
  return (0, _client.isJustGiving)() ? (0, _justgiving.fetchTeams)(params) : (0, _everydayhero.fetchTeams)(params);
};

var fetchTeam = exports.fetchTeam = function fetchTeam(params) {
  return (0, _client.isJustGiving)() ? (0, _justgiving.fetchTeam)(params) : (0, _everydayhero.fetchTeam)(params);
};

var createTeam = exports.createTeam = function createTeam(params) {
  return (0, _client.isJustGiving)() ? (0, _justgiving.createTeam)(params) : (0, _everydayhero.createTeam)(params);
};

var joinTeam = exports.joinTeam = function joinTeam(params) {
  return (0, _client.isJustGiving)() ? (0, _justgiving.joinTeam)(params) : (0, _everydayhero.joinTeam)(params);
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/teams/index.js
// module id = 1320
// module chunks = 0